import {createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import getInitialState from '../../../store/initial_state';
/* global photoOrg,eventBus */

export const getAlbumsPhotos = createAsyncThunk(
    "singleAlbum/albumPhotos",
    async (config, {rejectWithValue }) =>{
        try{
            const selectedAlbumResponse = await photoOrg.albumDataManager.getOwnedAlbumPhotos(config)
            .then((response) =>{
                return response.data;
            }).catch(function(err){
                photoOrg.albumFetcherObj.onError(err);
            });
            return selectedAlbumResponse;
        }catch (err){
            photoOrg.clientLogger.error({description: "LIBRARY:Slices:getAlbumsPhotos:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
            return rejectWithValue([], err);
        }
    }
);

export const getSharedSingleAlbumInfo = createAsyncThunk(
    "singleAlbum/friendsAlbumPhotos",
    async (config, {rejectWithValue }) =>{
        try{
            const selectedAlbumResponse = await photoOrg.shareDataManager.getSharedSingleAlbumInfo(config)
            .then((response) =>{
                return response.data;
            }).catch(function(err){
                photoOrg.albumFetcherObj.onError(err);
            });
            return selectedAlbumResponse;
        }catch (err){
            photoOrg.clientLogger.error({description: "LIBRARY:Slices:getSharedSingleAlbumInfo:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
            return rejectWithValue([], err);
        }
    }
);

const singleAlbumsSlice = createSlice({
    name: "singleAlbum",
    initialState: getInitialState(),
    reducers: {},
    extraReducers: (builder) => {},
});

export const { actions, reducer } = singleAlbumsSlice;
export default reducer;
